import { render, staticRenderFns } from "./Donora.vue?vue&type=template&id=286dd1c5&scoped=true"
import script from "./Donora.vue?vue&type=script&lang=js"
export * from "./Donora.vue?vue&type=script&lang=js"
import style0 from "./Donora.vue?vue&type=style&index=0&id=286dd1c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286dd1c5",
  null
  
)

export default component.exports